import React, { useRef, useEffect, useContext } from 'react';
import { NCContext } from '@wix/da-react-context/pkg/NCContext';
import LoadableDeviationPage from '../../DeviationPage/LoadableDeviationPage';
import { getStreamItemId } from '../redux/helpers';
import { DuperbrowseViewContext } from '../DuperbrowseViewContext';
import { scrollTo } from '../../utils/browser';
import { FEEDBACK_PAGE_DUPERBROWSE_ITEMID } from '../redux/constants';
import { useScrollRestore } from '../hooks/useScrollRestore';
import LoadingIndicator from '../../LoadingIndicator';
const DuperbrowsePageWrapper = ({ isDuperbrowseActive, currentItem, children, isLoading, justClosedAStream })=>{
    const { PageComponent } = useContext(NCContext);
    // on navigation, scroll back top
    const lastItemId = useRef();
    const currentItemId = currentItem && getStreamItemId(currentItem);
    // We use duperbrowse to render the NC (feedback) page here, because having another
    // page wrapper will result in conflicts - one of the page wrappers higher
    // in the tree will take over the page earlier.
    //
    // For NC we have a special duperbrowse stream with just one item.
    //
    // Opening and closing the NC is achieved by dispatching toggleFeedbackPage,
    // which in turn delegates to openDuperbrowse/exitDuperbrowse actions.
    const isFeedbackPageOpen = currentItemId === FEEDBACK_PAGE_DUPERBROWSE_ITEMID;
    // Because we don't use DeviationLink to open the NC page, we have to
    // restore scroll by remembering the last window scroll position.
    useScrollRestore(isFeedbackPageOpen);
    useEffect(()=>{
        // we do not want to scroll if we just returned from a nested stream
        // or if we don't have a current item (duper is inactive)
        // or if we are just re-rendering without a change to the current item
        if (!justClosedAStream && currentItemId && currentItemId !== lastItemId.current) {
            scrollTo(window, 0, 0);
        }
        lastItemId.current = currentItemId;
    }, [
        currentItemId,
        justClosedAStream
    ]);
    if (!isDuperbrowseActive) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    if (isFeedbackPageOpen) {
        // PageComponent represents the FeedbackPageLoadable in da-feedback-shared.
        // We can't import it directly because of circular deps.
        return PageComponent ? /*#__PURE__*/ React.createElement(PageComponent, {
            loadingIndicator: /*#__PURE__*/ React.createElement(LoadingIndicator, {
                view: "llama",
                coverMode: true
            })
        }) : /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement(DuperbrowseViewContext.Provider, {
        value: "fullscreen"
    }, /*#__PURE__*/ React.createElement(LoadableDeviationPage, {
        deviation: currentItem,
        isWholePageLoading: isLoading
    }));
};
DuperbrowsePageWrapper.displayName = 'DuperbrowsePageWrapper';
export default DuperbrowsePageWrapper;
